module.exports = __webpack_public_path__ + "img/1-8.fbb75d08.png";